

import React, { useEffect, useRef } from "react";
import "./walletbanner.scss";
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Header from "../../landing/Header/Header";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const Walletbanner = () => {
  const textRef = useRef(null);
  const paraRef = useRef(null);
  const buttonRefs = useRef([]);

  useEffect(() => {
    const tl = gsap.timeline();
  
    gsap.set(textRef.current, {
      clipPath: "inset(0% 100% 0% 0%)",
      opacity: 1,
    });
  
    tl.to(textRef.current, {
      clipPath: "inset(0% 0% 0% 0%)",
      duration: 1,
      ease: "power2.out",
      delay: 1, 
    });
  }, []);
  
  useEffect(() => {
    gsap.fromTo(
      paraRef.current,
      { opacity: 0, y: 50 },
      { opacity: 1, y: 0, duration: 1, ease: "power2.out", delay: 1 } 
    );
  }, []);
  
  useEffect(() => {
    if (buttonRefs.current.length === 0) return;
  
    gsap.set(buttonRefs.current, {
      clipPath: "inset(0% 100% 0% 0%)",
      opacity: 1,
    });
  
    gsap.timeline()
      .to(buttonRefs.current, {
        clipPath: "inset(0% 0% 0% 0%)",
        duration: 0.5,
        ease: "power2.out",
        stagger: 0,
        delay: 1, 
      })
      .to(buttonRefs.current, {
        rotateY: 360,
        duration: 0.8,
        ease: "power2.inOut",
        stagger: 0,
      });
  }, []);
  
  useEffect(() => {
    gsap.from(".breadvrumbcnt, .breadvrumbcntactive", {
      opacity: 0,
      y: 10,
      duration: 0.6,
      stagger: 0.2,
      ease: "power2.out",
      delay: 1, 
    });
  }, []);
  
  useEffect(() => {
    gsap.fromTo(
      ".fade-element",
      { x: 100, opacity: 0 },
      { x: 0, opacity: 1, duration: 1, delay: 1 } 
    );
  }, []);


   const breadcrumbSchema = {
      "@context": "https://schema.org/",
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": "https://tomi.com/"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Wallet", 
          "item": "https://tomi.com/Wallet"
        }
      ]
    };
  
    useEffect(() => {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.innerHTML = JSON.stringify(breadcrumbSchema);
      document.head.appendChild(script);
  
      return () => {
        document.head.removeChild(script);
      };
    }, []);
  
  return (
    <>
       <section className="bannermainprnt">
       <Header/>
        <div className="custom-container ">

          <div className="heromain">
            <div className="heroleftseaction">
              <div className="textherobanner">

                <nav aria-label="breadcrumb"> 
                  <Breadcrumb className="breadcrumbprnt">
                    <Breadcrumb.Item className="breadvrumbcnt" href="/">
                      Home
                    </Breadcrumb.Item>
                    <Breadcrumb.Item
                      className="breadvrumbcntactive"
                    >
                     Wallet
                    </Breadcrumb.Item>
                  </Breadcrumb>
                </nav>
                <h2 ref={textRef}>The First AI-Powered Crypto Wallet</h2>
                <p ref={paraRef}>Send, Swap & Manage with Your Voice</p>

              </div>
              <div className="walletbannerbtn">

              <a ref={(el) => (buttonRefs.current[0] = el)}  className="herofeaturebannerbtn primerybtn"
                 href="https://play.google.com/store/apps/details?id=com.tomiapp.production&hl=en" target="_blank">
                <img src="\assets\Wallet\playstorebtnbanner.svg" alt="playstoreimg" />
              </a>
              <a ref={(el) => (buttonRefs.current[1] = el)} className="herofeaturebannerbtn primerybtn"
                href="https://apps.apple.com/us/app/tomi-ai-crypto-wallet/id1643501440" target="_blank">
                <img src="\assets\Wallet\Appstorebtnbanner.svg" alt="Appstoreimg" />
              </a>
              </div>
            </div>
            <div className="herorightseaction displaynoneonmobile">
              <img className="img-fluid fade-element" src="\assets\Wallet\walletbannerimg.png" alt="The First AI-Powered Crypto Wallet - tomi" />
            </div>
            <div className="herorightseaction d-none displayshowonmobile">
              <img className="img-fluid fade-element d-block m-auto" src="\assets\Wallet\walletbannerimgmbl.png" alt="The First AI-Powered Crypto Wallet - tomi" />
            </div>
          </div>
        </div>
      </section >
    </>
  )
}

export default Walletbanner